import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { SAPin } from "../../../../app-constants";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question:
      "How to choose the right software development company in Saudi Arabia?",
    answer: `<p>When selecting a software development company in Saudi Arabia, analyze the rates and choose one that suits your budget. However, choosing a company based purely on its pricing can result in unexpected charges. Before hiring a software company, you should also consider the organization's professional knowledge.</p>`,
  },
  {
    question: "What is a custom software development company?",
    answer: `<p>Custom software development is the process of creating software apps that are customized to the exact requirements of an enterprise. However, custom solutions, as opposed to commercial off-the-shelf (COTS) software, are typically designed to address specific issues. They are also intended for in-house use rather than selling.</p>`,
  },
  {
    question: "How to hire a software development company to build an app?",
    answer: `<p>Here are the steps to hire a software development company:</p>
        <ul>
                 <li>Define clear project requirements</li>
                 <li> Research & shortlist reputable software companies in Saudi Arabia</li>
                 <li>Evaluate their portfolio and client reviews</li>
                 <li>Assess expertise in relevant technologies</li>
                 <li>Ask about their development process and tech stack</li>
                 <li>Request a detailed cost of custom software development and timeline</li>
                 <li>Verify the company's experience in app security</li>
                 <li>Confirm post-launch support and maintenance options</li>
             </ul>
        `,
  },
  {
    question: "Which programming language is best for software development?",
    answer: `<p>Here are the programming languages best for software development:</p>
        <ul>
            <li>JavaScript</li>
            <li>HTML/CSS</li>
            <li>Python</li>
            <li>SQL</li>
            <li>TypeScript</li>
            <li>Java</li>
            <li>C++</li>
            <li>C#</li>
            <li>PHP</li>
            <li>Swift</li>
            <li>Kotlin</li>
        </ul>
   `,
  },
  {
    question: "How much does it cost to develop custom software?",
    answer: `<p>The cost of a software project depends on several factors including the project scope, time spent, and technological issues.</p>
        <p>Each project is unique, so providing an accurate estimate cost of custom software development is difficult. You can schedule a free consultation with us to get the estimated cost of your project.</p>
  `,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>
          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{SAPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
